// // src/utils/generateWarehouseReport.js
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import moment from "moment";

// const HEADER_BG = "FF1F3864";
// const VENDOR_BG = "FF4472C4";
// const FIELD_BG = "FFFFF2CC";

// export const generateWarehouseReport = async (order) => {
//   const wb = new ExcelJS.Workbook();
//   const ws = wb.addWorksheet("Warehouse Report");

//   ws.columns = [
//     { width: 8 }, { width: 20 }, { width: 16 }, { width: 24 },
//     { width: 22 }, { width: 18 }, { width: 12 }, { width: 12 },
//     { width: 14 }, { width: 26 },
//   ];

//   // ===== Row 1: Title =====
//   ws.mergeCells("A1:F1");
//   ws.mergeCells("G1:J1");
//   const titleStyle = (cell, text) => {
//     cell.value = text;
//     cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 13 };
//     cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: HEADER_BG } };
//     cell.alignment = { vertical: "middle", horizontal: "center" };
//   };
//   titleStyle(ws.getCell("A1"), "WAREHOUSE RECEIVING REPORT");
//   titleStyle(ws.getCell("G1"), `DATE GENERATED: ${moment().format("MM/DD/YYYY")}`);
//   ws.getRow(1).height = 28;

//   // ===== Rows 3 & 5: Info fields =====
//   const setLabel = (addr, text) => {
//     const c = ws.getCell(addr);
//     c.value = text;
//     c.font = { bold: true };
//     c.alignment = { vertical: "middle", horizontal: "right" };
//   };
//   const setValue = (addr, mergeRange, text) => {
//     ws.mergeCells(mergeRange);
//     const c = ws.getCell(addr);
//     c.value = text || "";
//     c.font = { bold: true };
//     c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: FIELD_BG } };
//     c.alignment = { vertical: "middle", horizontal: "center" };
//     c.border = {
//       top: { style: "thin" }, bottom: { style: "thin" },
//       left: { style: "thin" }, right: { style: "thin" },
//     };
//   };
//   const fmt = (d) => (d ? moment(d).format("MM/DD/YYYY") : "");

//   setLabel("A3", "CONTRACT VEHICLE:");
//   setValue("B3", "B3:C3", order?.ContractType?.name);
//   setLabel("D3", "SALES LEAD:");
//   setValue("E3", "E3:F3", order?.sales_lead_name);
//   setLabel("G3", "EST. FULLFILLMENT DATE:");
//   setValue("H3", "H3:J3", fmt(order?.estimated_date));

//   setLabel("A5", "ORDER ID:");
//   setValue("B5", "B5:C5", order?.order_id);
//   setLabel("D5", "CREATED DATE:");
//   setValue("E5", "E5:F5", fmt(order?.published_date));
//   setLabel("G5", "EST. WAREHOUSE DATE:");
//   setValue("H5", "H5:J5", fmt(order?.actual_date));

//   ws.getRow(3).height = 22;
//   ws.getRow(5).height = 22;

//   // ===== Row 7: Table headers =====
//   ws.mergeCells("E7:F7");
//   const headers = {
//     A7: "Line #", B7: "Vendor", C7: "SKU", D7: "Product Name",
//     E7: "Product Description", G7: "Qty Expected", H7: "Qty Received",
//     I7: "Discrepancy", J7: "Notes",
//   };
//   Object.entries(headers).forEach(([addr, val]) => {
//     const c = ws.getCell(addr);
//     c.value = val;
//     c.font = { bold: true, color: { argb: "FFFFFFFF" } };
//     c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: HEADER_BG } };
//     c.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
//     c.border = {
//       top: { style: "thin" }, bottom: { style: "thin" },
//       left: { style: "thin" }, right: { style: "thin" },
//     };
//   });
//   ws.getRow(7).height = 38;

//   // ===== Group OrderProducts by vendor display_name =====
//   const products = order?.OrderProducts || [];
//   const grouped = products.reduce((acc, p) => {
//     const name = p.Vendor?.display_name || p.display_name || "Unknown Vendor";
//     (acc[name] = acc[name] || []).push(p);
//     return acc;
//   }, {});

//   const thin = { style: "thin", color: { argb: "FFBFBFBF" } };
//   const cellBorder = { top: thin, bottom: thin, left: thin, right: thin };

//   let row = 8;
//   let lineNo = 1;

//   Object.entries(grouped).forEach(([vendorName, items]) => {
//     // Vendor group header
//     ws.mergeCells(`A${row}:J${row}`);
//     const vc = ws.getCell(`A${row}`);
//     vc.value = vendorName.toUpperCase();
//     vc.font = { bold: true, color: { argb: "FFFFFFFF" } };
//     vc.fill = { type: "pattern", pattern: "solid", fgColor: { argb: VENDOR_BG } };
//     vc.alignment = { vertical: "middle", horizontal: "left", indent: 1 };
//     ws.getRow(row).height = 22;
//     row++;

//     items.forEach((p) => {
//       ws.mergeCells(`E${row}:F${row}`);
//       const r = ws.getRow(row);
//       r.getCell(1).value = lineNo;
//       r.getCell(2).value = p.Vendor?.display_name || p.display_name || "";
//       r.getCell(3).value = p.sku_display_name || p.sku_id || "";
//       r.getCell(4).value = p.name || "";
//       r.getCell(5).value = p.description || "";
//       r.getCell(7).value = Number(p.quantity) || 0;
//       r.getCell(8).value = 0;
//       r.getCell(9).value = { formula: `IF(H${row}="","",H${row}-G${row})` };
//       r.getCell(10).value = "";

//       for (let col = 1; col <= 10; col++) {
//         if (col === 6) continue; // merged into E
//         const c = r.getCell(col);
//         c.alignment = {
//           vertical: "middle",
//           horizontal: col === 4 || col === 5 ? "left" : "center",
//           wrapText: true,
//         };
//         c.border = cellBorder;
//       }
//       r.height = 22;
//       row++;
//       lineNo++;
//     });
//   });

//   const buffer = await wb.xlsx.writeBuffer();
//   saveAs(
//     new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
//     `Warehouse_Report_${order?.order_id || "Order"}.xlsx`
//   );
// };

// src/utils/generateWarehouseReport.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";

const HEADER_BG = "FF1F3864";
const VENDOR_BG = "FF4472C4";
const FIELD_BG = "FFFFF2CC";

export const generateWarehouseReport = async (order) => {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Warehouse Report");

  ws.columns = [
    { width: 7 },   // A: Line #
    { width: 18 },  // B: Vendor
    { width: 16 },  // C: Vendor
    { width: 18 },  // D: SKU
    { width: 18 },  // E: Product Name
    { width: 14 },  // F: Product Name
    { width: 20 },  // G: Product Desc
    { width: 16 },  // H: Product Desc
    { width: 12 },  // I: Qty Expected
    { width: 12 },  // J: Qty Received
    { width: 14 },  // K: Discrepancy
    { width: 22 },  // L: Notes
  ];

  // ===== Row 1: Title =====
  ws.mergeCells("A1:F1");
  ws.mergeCells("G1:L1");
  const titleStyle = (cell, text) => {
    cell.value = text;
    cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 13 };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: HEADER_BG } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
  };
  titleStyle(ws.getCell("A1"), "WAREHOUSE RECEIVING REPORT");
  titleStyle(ws.getCell("G1"), `DATE GENERATED: ${moment().format("MM/DD/YYYY")}`);
  ws.getRow(1).height = 28;

  // ===== Info rows =====
  const setLabel = (mergeRange, text) => {
    ws.mergeCells(mergeRange);
    const c = ws.getCell(mergeRange.split(":")[0]);
    c.value = text;
    c.font = { bold: true };
    c.alignment = { vertical: "middle", horizontal: "right" };
  };
  const setValue = (mergeRange, text) => {
    ws.mergeCells(mergeRange);
    const c = ws.getCell(mergeRange.split(":")[0]);
    c.value = text || "";
    c.font = { bold: true };
    c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: FIELD_BG } };
    c.alignment = { vertical: "middle", horizontal: "center" };
    c.border = {
      top: { style: "thin" }, bottom: { style: "thin" },
      left: { style: "thin" }, right: { style: "thin" },
    };
  };
  const fmt = (d) => (d ? moment(d).format("MM/DD/YYYY") : "");

  // Row 3: label (2 cells) | value (2 cells) x 3
  setLabel("A3:B3", "CONTRACT VEHICLE:");
  setValue("C3:D3", order?.ContractType?.name);
  setLabel("E3:F3", "SALES LEAD:");
  setValue("G3:H3", order?.sales_lead_name);
  setLabel("I3:J3", "EST. FULLFILLMENT DATE:");
  setValue("K3:L3", fmt(order?.estimated_date));

  // Row 5
  setLabel("A5:B5", "ORDER ID:");
  setValue("C5:D5", order?.order_id);
  setLabel("E5:F5", "CREATED DATE:");
  setValue("G5:H5", fmt(order?.published_date));
  setLabel("I5:J5", "EST. WAREHOUSE DATE:");
  setValue("K5:L5", fmt(order?.actual_date));

  ws.getRow(3).height = 26;
  ws.getRow(5).height = 26;

  // ===== Row 7: Table headers =====
  ws.mergeCells("B7:C7"); // Vendor
  ws.mergeCells("E7:F7"); // Product Name
  ws.mergeCells("G7:H7"); // Product Description
  const headers = {
    A7: "Line #", B7: "Vendor", D7: "SKU", E7: "Product Name",
    G7: "Product Description", I7: "Qty Expected", J7: "Qty Received",
    K7: "Discrepancy", L7: "Notes",
  };
  Object.entries(headers).forEach(([addr, val]) => {
    const c = ws.getCell(addr);
    c.value = val;
    c.font = { bold: true, color: { argb: "FFFFFFFF" } };
    c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: HEADER_BG } };
    c.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    c.border = {
      top: { style: "thin" }, bottom: { style: "thin" },
      left: { style: "thin" }, right: { style: "thin" },
    };
  });
  ws.getRow(7).height = 38;

  // ===== Group OrderProducts by vendor display_name =====
  const products = order?.OrderProducts || [];
  const grouped = products.reduce((acc, p) => {
    const name = p.Vendor?.display_name || p.display_name || "Unknown Vendor";
    (acc[name] = acc[name] || []).push(p);
    return acc;
  }, {});

  const thin = { style: "thin", color: { argb: "FFBFBFBF" } };
  const cellBorder = { top: thin, bottom: thin, left: thin, right: thin };

  let row = 8;
  let lineNo = 1;

  Object.entries(grouped).forEach(([vendorName, items]) => {
    ws.mergeCells(`A${row}:L${row}`);
    const vc = ws.getCell(`A${row}`);
    vc.value = vendorName.toUpperCase();
    vc.font = { bold: true, color: { argb: "FFFFFFFF" } };
    vc.fill = { type: "pattern", pattern: "solid", fgColor: { argb: VENDOR_BG } };
    vc.alignment = { vertical: "middle", horizontal: "left", indent: 1 };
    ws.getRow(row).height = 22;
    row++;

    items.forEach((p) => {
      ws.mergeCells(`B${row}:C${row}`);
      ws.mergeCells(`E${row}:F${row}`);
      ws.mergeCells(`G${row}:H${row}`);

      const r = ws.getRow(row);
      r.getCell(1).value = lineNo;
      r.getCell(2).value = p.Vendor?.display_name || p.display_name || "";
      r.getCell(4).value = p.sku_display_name || p.sku_id || "";
      r.getCell(5).value = p.name || "";
      r.getCell(7).value = p.description || "";
      r.getCell(9).value = Number(p.quantity) || 0;
      r.getCell(10).value = 0;
      r.getCell(11).value = { formula: `IF(J${row}="","",J${row}-I${row})` };
      r.getCell(12).value = "";

      [1, 2, 4, 5, 7, 9, 10, 11, 12].forEach((col) => {
        const c = r.getCell(col);
        c.alignment = {
          vertical: "middle",
          horizontal: col === 5 || col === 7 ? "center" : "center",
          wrapText: true,
        };
        c.border = cellBorder;
      });
      r.height = 22;
      row++;
      lineNo++;
    });
  });

  const buffer = await wb.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
    `Warehouse_Report_${order?.order_id || "Order"}.xlsx`
  );
};